export const separarNombreYApellidos = (nombreCompleto) => {
    const [nombre, ...apellidos] = nombreCompleto.split(' ');
    return { nombre, apellidos: apellidos.join(' ') };
};